var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useLoanNickNameMutation } from "../../../queries/useLoanNickNameMutation/useLoanNickNameMutation";
import { useConfig } from "../../../hooks/useConfig";
import i18n from "../../../strings/i18n";
import { BodyWrapper, FooterButton, FooterWrapper, Header, HeaderWrapper, ModalBody, ModalContent, NickNameError, NickNameInput, NickNameModal, } from "./LoanNickNameModal.styles";
var LoanNickNameModal = function (_a) {
    var containerId = _a.containerId, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, accountId = _a.accountId, nickName = _a.nickName;
    var config = useConfig();
    var _b = useState(nickName || ""), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState(), err = _c[0], setErr = _c[1];
    var _d = useState(false), apiError = _d[0], setApiError = _d[1];
    var updateNickName = useLoanNickNameMutation({
        config: config,
        keyProps: { accountId: accountId, accountIdType: "guid" },
    });
    var handleInputChange = function (value) {
        setInputValue(value);
        if (value.length > 52) {
            setErr("".concat(value.length, "/52"));
        }
        else
            setErr(undefined);
    };
    var closeModal = function () {
        setIsOpen(false);
        setInputValue("");
        setErr(undefined);
        if (apiError)
            setApiError(false);
    };
    var handleSuccess = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updateStatus, _e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!err) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateNickName.mutateAsync({
                            nickName: inputValue,
                        })];
                case 2:
                    updateStatus = (_a.sent()).updateStatus;
                    if (updateStatus === "Success") {
                        setInputValue("");
                        closeModal();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e_1 = _a.sent();
                    setApiError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(NickNameModal, __assign({ id: "simple-modal", containerId: containerId, "aria-label": "Nick name modal", "data-testid": "nick-name-modal", isOpen: isOpen, className: "nick-name-modal", escapeModalHandler: closeModal }, { children: _jsx(ModalContent, __assign({ id: "modal-content" }, { children: apiError ? (_jsx(NickNameError, { img: "".concat(config.hosts.assets, "/assets/account-card/nickname/nickname_error.svg"), handleClose: closeModal })) : (_jsxs(_Fragment, { children: [_jsx(HeaderWrapper, { children: _jsx(Header, { children: i18n({ labels: "loanNickNameHeader" }) }) }), _jsx(BodyWrapper, { children: _jsx(ModalBody, { children: i18n({ labels: "loanNicknameText" }) }) }), _jsx(NickNameInput, { inputValue: inputValue, handleInputChange: handleInputChange, error: err }), _jsxs(FooterWrapper, { children: [_jsx(FooterButton, __assign({ id: "nickname-close", "data-testid": "nickname-close", ariaLabel: "Close nickname modal", buttonType: "ghost", onClick: function (e) {
                                    e.stopPropagation();
                                    closeModal();
                                } }, { children: i18n({ button: "cancel" }) })), _jsx(FooterButton, __assign({ id: "nickname-submit", "data-testid": "nickname-submit", ariaLabel: "Submit nickname", buttonType: "primary", onClick: function (e) {
                                    e.stopPropagation();
                                    handleSuccess();
                                } }, { children: i18n({ button: "save" }) }))] })] })) })) })));
};
export default LoanNickNameModal;
//# sourceMappingURL=LoanNickNameModal.js.map